import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InfoBox, otherColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledDeleteWarningIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.error.main};
  width: 2.4rem;
  height: 2.4rem;
  padding-top: 0.4rem;
`;

export const StyledLabel = styled.p`
  font-size: 1.6rem;
  line-height: 1.6rem;
  white-space: nowrap;
  padding: 1rem 0;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledInfoBox = styled(InfoBox)<{ isDark: boolean }>`
  display: flex;
  align-items: center;
  gap: 1.4rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.error.main};
  background-color: ${({ isDark }) => (isDark ? otherColors.red2[10] : 'rgba(253, 230, 235, 1)')};
`;

export const StyledDeleteWarningBoxText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledWarningBoxIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.error.main};
  width: 2rem;
  height: 2rem;
`;
